module.exports = __webpack_public_path__ + "img/tb_3.55ef631f.png";